import type { Egenskapstype as ApiEgenskapstype } from '@/generated/nvdb/datakatalog/models';
import {
    Egenskapstype,
    EgenskapTillattVerdi,
    Enhet,
} from '@/domain/vegobjekter/Egenskapstype';
import { EgenskapsTypeEnum } from '@/domain/vegobjekter/EgenskapsTypeEnum';

type ApiEgenskapstypeResponse = ApiEgenskapstype & {
    feltlengde?: number;
    desimaler?: number;
    min_anbefalt?: number | string;
    maks_anbefalt?: number | string;
    min?: number;
    maks?: number;
    egenskapstyper?: ApiEgenskapstypeResponse[];
    tillatte_verdier?: Array<{
        id: number;
        kortnavn?: string;
        verdi?: string | number;
        type: string;
        sorteringsnummer: number;
    }>;
    enhet?: Enhet;
    geometritype?: string;
    geometriType?: string;
    dimensjon?: number;
    stedfestingstype?: string;
    retning_relevant?: boolean;
};

export function transformEgenskapstype(e: ApiEgenskapstype): Egenskapstype {
    const data = e as ApiEgenskapstypeResponse;

    return new Egenskapstype(
        data.id,
        data.kategori,
        data.navn ?? '',
        data.kortnavn ?? '',
        data.beskrivelse ?? '',
        data.veiledning ?? '',
        data.egenskapstype as EgenskapsTypeEnum,
        data.sosinvdbnavn ?? '',
        data.sosinavn ?? '',
        data.sorteringsnummer,
        data.feltlengde ?? 0,
        data.desimaler ?? 0,
        data.min_anbefalt as number,
        data.maks_anbefalt as number,
        data.min ?? 0,
        data.maks ?? 0,
        data.sensitivitet,
        data.viktighet as unknown as number,
        (data.egenskapstyper || []).map(transformEgenskapstype),
        (data.tillatte_verdier || []).map(
            tv =>
                new EgenskapTillattVerdi(
                    tv.id,
                    tv.kortnavn ?? '',
                    tv.verdi ?? '',
                    tv.type,
                    tv.sorteringsnummer
                )
        ),
        data.enhet as Enhet,
        data.dimensjon ?? 0,
        data.geometritype ?? data.geometriType ?? '',
        data.stedfestingstype ?? '',
        data.retning_relevant ?? false
    );
}
